import runAsync from '@/script/runAsync.mjs'

export const lint = () => () => {
    return async function (nodes, type) {
        await runAsync(
            async () => {
                try {
                    await this.execute(async () => {
                        for (const n of nodes) {
                            const _n = this.nodeProxy(n)
                            await _n.lintTree(type)
                        }
                    })
                }
                catch (err) {
                    if ('ValidationError' === err.name) {
                        this.execute(
                            () => this.selectNodes([err.target])
                        )
                    }

                    throw err
                }
            },

            {action: '规范性检测'}
        )
    }
}
